import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import FuseLoading from '@fuse/core/FuseLoading';
import OAuthService from '../../auth/services/oAuthService/oAuthService';
import CommonDashboard from './CommonDashboard';
import jwtDecode from 'jwt-decode';
import { Typography, Box, Button } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import DashboardLockButton from './components/DashboardLockButton';

const REQUIRED_ROLE = 'ROLE_DASHBOARDSCREEN';

const DashboardAuth = () => {
    const [accessStatus, setAccessStatus] = useState('loading');
    const dispatch = useDispatch();

    useEffect(() => {
        const initAuth = async () => {
            let token = localStorage.getItem('access_token');
            let success = false;

            if (!token) {
                success = await OAuthService.signInWithClientCredentials();
                if (success) {
                    token = localStorage.getItem('access_token');
                } else {
                    setAccessStatus('denied');
                    dispatch(showMessage({ message: 'Dashboard Authentication Failed', variant: 'error' }));
                    return;
                }
            }

            try {
                const decoded = jwtDecode(token);
                const userRoles = decoded.scope || decoded.roles || [];
                const rolesArray = Array.isArray(userRoles) ? userRoles : userRoles.split(' ');

                if (rolesArray.includes(REQUIRED_ROLE)) {
                    setAccessStatus('granted');
                } else {
                    console.warn(`Access Denied: Missing ${REQUIRED_ROLE}`, rolesArray);
                    setAccessStatus('denied');
                }
            } catch (error) {
                console.error("Token decoding failed:", error);
                setAccessStatus('denied');
            }
        };

        initAuth();
    }, [dispatch]);

    if (accessStatus === 'loading') {
        return <FuseLoading />;
    }

    if (accessStatus === 'denied') {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', textAlign: 'center', p: 3 }}>
                <ErrorIcon sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
                <Typography variant="h5" gutterBottom>Access Denied</Typography>
                <Typography color="text.secondary" sx={{ mb: 3 }}>
                    You do not have the required permissions ({REQUIRED_ROLE}) to view this dashboard.
                </Typography>
                <Button variant="outlined" onClick={() => window.location.reload()}>
                    Retry
                </Button>
            </Box>
        );
    }

    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <CommonDashboard />
            <DashboardLockButton />
        </div>
    );
};

export default DashboardAuth;